/** @format */

import React from 'react';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { create } from 'jss';
import rtl from 'jss-rtl';
import StylesProvider from '@mui/styles/StylesProvider';
import jssPreset from '@mui/styles/jssPreset';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const emotionCache = createCache({
  key: 'mui-rtl',
  prepend: true,
  stylisPlugins: [prefixer, rtlPlugin],
});

function RTL(props) {
  return (
    <CacheProvider value={emotionCache}>
      <StylesProvider jss={jss}>{props.children}</StylesProvider>
    </CacheProvider>
  );
}

export default RTL;
